import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNoticeList } from "../@apis/hooks/useCommunity";
import { useGetMain } from "../@apis/hooks/useMain";
import MainAppBar from "../components/atoms/appbar/MainAppbar";
import Button from "../components/atoms/button";
import Footer from "../components/layout/footer";
import HomeQrSwiper from "../components/layout/home/HomeQrSwiper";
import { useModalStore } from "../lib/store/useModalStore";
import { cn } from "../lib/utils/cn";
import { staticURL } from "../lib/utils/imageUtils";
import { vw } from "../lib/utils/responsiveUtils";

const CAROUSEL_AUTOPLAY_DELAY_MS = 2000;

export default function Home() {
  const navigate = useNavigate();
  const { openModal } = useModalStore();

  const { data, isSuccess: isNoticeSuccess } = useQuery({ ...useNoticeList({ pageSize: 5 }) });
  const notices = data?.data?.noticeList ?? [];

  // STATE
  const [itemIndex, setItemIndex] = React.useState(0);
  const [noticeIndex, setNoticeIndex] = React.useState(0);

  const handleClickNoticeBox = () => {
    if (!notices.length) return;

    const currentNotice = notices[noticeIndex] || notices[0];
    navigate(`/notice/${currentNotice.id}`);
  };

  // const coords = useGeoStore((s) => s.coords);
  const { data: mainInfo, isSuccess } = useQuery({
    ...useGetMain({ pageSize: 6 }),
    // coords ? { latitude: coords.latitude, longitude: coords.longitude } : undefined
  });
  const golfParkList = mainInfo?.data?.golfParkList || [];
  const tournamentInfoList = mainInfo?.data?.tournamentInfoList || [];

  // const payMutation = useMutation({
  //   mutationFn: ({id, type}: {id: number; type: string;}) => payRequest({id, type}),
  //   onSuccess: (res) => {
  //     const { success, data, error } = res;
  //     if (success) {
  //       const { nicePayRequest } = data;
  //       handlePayment({
  //         EdiDate: nicePayRequest.EdiDate,
  //         Moid: nicePayRequest.Moid,
  //         SignData: nicePayRequest.SignData,
  //         ReturnUrl: nicePayRequest.ReturnUrl,
  //         BuyerName: nicePayRequest.BuyerName,
  //         BuyerTel: nicePayRequest.BuyerTel,
  //         BuyerEmail: nicePayRequest.BuyerEmail,
  //         TransType: nicePayRequest.TransType,
  //         CharSet: nicePayRequest.CharSet
  //       })
  //     } else {
  //       console.log(error)
  //     }
  //   },
  //   onError: (err: OnErrorResponse) => {
  //     console.log(err)
  //   }
  // })

  // const handlePayment = (pay: PaymentRequest) => {
  //   window.nicepay.requestPay({
  //     ...pay,
  //     fnError: function(res) {
  //       alert('결제에 실패했습니다');
  //       console.log(res);
  //     }
  //   })
  // }

  React.useEffect(() => {
    if (dayjs().isSameOrBefore("2025-10-24", "day")) {
      openModal("NOTICE_MODAL");
    }
  }, [openModal]);

  return (
    <section className="flex flex-col justify-between bg-[#f5f5f5] min-h-full relative">
      <div>
        <MainAppBar height={60} />
        <div className="absolute top-[56px] left-0 w-full h-[60px] bg-gradient-to-t from-transparent to-white pointer-events-none" />

        <section className="w-full px-[15px]">
          <div
            className="mt-auto flex-row px-5 rounded-[10px] bg-white gap-[10px] h-[50px]"
            onClick={handleClickNoticeBox}
          >
            <img className="w-[0.6rem]" src="/icons/ic-notice.webp" />
            {notices.length > 0 ? (
              <div className="w-full h-[50px] flex-row-between gap-2">
                <Swiper
                  style={{
                    margin: 0,
                  }}
                  className="h-full"
                  key={notices.length}
                  direction="vertical"
                  // loop={notices.length > 1} // 슬라이드가 2개 이상일 때만 무한 루프
                  slidesPerView={1}
                  centeredSlides={true}
                  // autoplay={{
                  //   delay: 10000, // 10초마다 자동 전환
                  //   disableOnInteraction: false, // 사용자가 조작해도 자동 재생 유지
                  // }}
                  observer={true}
                  observeParents={true}
                  updateOnWindowResize={true}
                  onSlideChange={(swiper) => {
                    if (!isNaN(swiper.realIndex)) {
                      setNoticeIndex(swiper.realIndex);
                    }
                  }}
                  modules={[Autoplay, Pagination, Navigation]}
                >
                  {isNoticeSuccess &&
                    notices.map(({ title }, index) => (
                      <SwiperSlide key={index}>
                        <div className="h-[50px] flex items-center">
                          <p
                            className="flex-1 w-full text-left font-[500] text-xs truncate"
                            key={index}
                          >
                            {title}
                          </p>
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
                <p className="font-[500] text-xs">
                  {noticeIndex + 1}/{notices.length}
                </p>
              </div>
            ) : (
              <p className="text-xs font-[500] text-[#ccc]">
                공지사항이 없습니다.
              </p>
            )}
          </div>
        </section>
        {/* QR 영역 */}
        <HomeQrSwiper />

        <section className="pt-[25px]">
          <Swiper
            key={golfParkList.length}
            modules={[Autoplay, Pagination, Navigation]}
            loop={golfParkList.length > 1} // 슬라이드가 2개 이상일 때만 무한 루프
            slidesPerView={"auto"}
            centeredSlides={true}
            onSlideChange={(swiper) => {
              if (!isNaN(swiper.realIndex)) {
                setItemIndex(swiper.realIndex);
              }
            }}
            spaceBetween={20}
            observer={true}
            observeParents={true}
            updateOnWindowResize={true}
            autoplay={{
              delay: CAROUSEL_AUTOPLAY_DELAY_MS,
              disableOnInteraction: false,
            }}
            pagination={{
              el: ".custom-pagination-container",
              clickable: true,
            }}
          >
            {isSuccess &&
              golfParkList.map((item, index) => {
                // const hasTournament = tournamentInfoList.some((t) =>
                //     t.golfParkCode.includes(String(item.code)),
                // );
                return (
                  <SwiperSlide key={index} style={{ width: vw(305) }}>
                    <div className="text-center">
                      <div
                        className={cn(
                          `rounded-[15px] shadow-[0px 15px 30px 0 rgba(0,0,0,0.15)] bg-[#fff] flex-row justify-center relative`,
                        )}
                        style={{
                          width: vw(305),
                          height: vw(305),
                        }}
                        onClick={() => {
                          navigate(`/store/${golfParkList[itemIndex]?.code}`);
                        }}
                      >
                        {item.imageUrl ? (
                          <img
                            src={staticURL(item.imageUrl)}
                            alt="_blank"
                            className="rounded-[15px]"
                            style={{ width: vw(305), height: vw(305) }}
                          />
                        ) : (
                          <img
                            src="/images/img-login-logo.webp"
                            alt="_blank"
                            style={{ width: vw(140), height: vw(129) }}
                          />
                        )}
                        {item.isShowProgressIcon && (
                          <div className="absolute top-[10px] left-[10px] bg-red-500 text-white rounded-[8px] px-[10px] py-[4px] flex-row items-center gap-[4px]">
                            <img
                              className="w-[0.5rem] h-auto"
                              src="/icons/ic-tournament.webp"
                              alt="tournament"
                            />
                            <span className="font-bold text-xs">대회중</span>
                          </div>
                        )}
                        {item.isShowApplyIcon && (
                          <div className="absolute top-[10px] right-[10px] ring ring-red-500 bg-white rounded-[5px] px-[10px] py-[4px] flex-row items-center gap-[4px]">
                            <span className="font-bold text-xs text-red-500">
                              대회 접수중
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
          {golfParkList.length > 0 && isSuccess && (
            <div className="text-center px-[35px] mt-[25px]">
              <p className="font-bold text-xl whitespace-pre-line break-keep break-words">
                {golfParkList[itemIndex]?.name}
              </p>
              <div className="flex-row justify-center gap-1 pt-2 items-start">
                <img
                  className="size-[0.75rem]"
                  src="/icons/ic-place-gray.webp"
                  alt="place"
                />
                <p className="text-[#888] font-[500] whitespace-pre-line break-keep text-xs break-words">
                  {golfParkList[itemIndex]?.address}
                </p>
              </div>
              <div className="w-full pt-[20px] space-y-[10px]">
                {(() => {
                  const matched = tournamentInfoList.find(
                    (t) =>
                      t.scoreCardId != null &&
                      t.golfParkCode.includes(
                        String(golfParkList[itemIndex]?.code),
                      ),
                  );
                  if (!matched) return null;
                  return (
                    <Button
                      className="w-full py-2"
                      variant="red"
                      onClick={() => navigate(`/score/${matched.scoreCardId}`)}
                    >
                      <div className="flex items-center gap-[10px]">
                        <img
                          className="h-6"
                          src="/icons/ic-tournament.webp"
                          alt="score icon"
                        />
                        <span className="text-base break-words break-keep whitespace-pre-line">
                          대회 스코어 확인
                        </span>
                      </div>
                    </Button>
                  );
                })()}
                <Button
                  className="w-full py-2 "
                  variant={"black"}
                  onClick={() => {
                    navigate(`/store/${golfParkList[itemIndex]?.code}`);
                  }}
                >
                  <span className="text-base break-words break-keep whitespace-pre-line">
                    골프장 정보
                  </span>
                </Button>
              </div>
            </div>
          )}
          <div className="custom-pagination-container text-center w-full mt-[25px]" />
        </section>
      </div>

      {/* <MarqueeChips className="mb-[5px] mt-[72px]" /> */}
      <Footer />

      {/* AI 콜봇 (플로팅 버튼 + 바텀시트) */}
      {/* <AiCallBotFab /> */}
    </section>
  );
}
